/**
 * All different types of items, that are accepted by DEXF.
 *
 * Note: Custom Kompis item types like bundles are not included in this enum.
 */
var ItemTypeEnum;
(function (ItemTypeEnum) {
    ItemTypeEnum["art"] = "ART";
    ItemTypeEnum["spr"] = "SPR";
    ItemTypeEnum["ext"] = "EXT";
    ItemTypeEnum["asl"] = "ASL";
    ItemTypeEnum["msc"] = "MSC";
    ItemTypeEnum["asm"] = "ASM";
    ItemTypeEnum["asp"] = "ASP";
})(ItemTypeEnum || (ItemTypeEnum = {}));
export default ItemTypeEnum;
//# sourceMappingURL=ItemTypeEnum.js.map